// removed by extract-text-webpack-plugin
module.exports = {"app":"AppPrintEditor__app___2DhEZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AppPrintEditor.scss
 ** module id = 647
 ** module chunks = 0
 **/